<template>
  <div class="birth-day-page">
    <!-- Header Section -->
    <AppHeader 
      header-text="Drivers in your state can save up to $600/year"
      button-text="FREE CALL"
    />

    <!-- Progress Bar -->
    <div class="progress-container">
      <div class="progress-bar">
        <div class="progress-fill"></div>
      </div>
    </div>

    <!-- Navigation -->
    <div class="navigation">
      <div class="container">
        <button class="back-btn" @click="goBack">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M15 18L9 12L15 6" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
          Previous Question
        </button>
      </div>
    </div>

    <!-- Birth Day Section -->
    <section class="birth-day-section">
      <div class="container">
        <div class="birth-day-content">
          <PageTitle title="Birth Day" />
          
          <div class="days-grid">
            <button 
              v-for="day in availableDays" 
              :key="day"
              :class="['day-button', { 'selected': selectedDay === day }]"
              @click="selectDay(day)"
            >
              {{ day }}
            </button>
          </div>
        </div>
      </div>
    </section>

    <!-- Footer Links -->
    <AppFooter />
  </div>
</template>

<script>
import AppHeader from '@/components/AppHeader.vue'
import AppFooter from '@/components/AppFooter.vue'
import PageTitle from '@/components/PageTitle.vue'
import { submitDataAndLog } from '@/utils/localStorage'

export default {
  name: 'BirthDayPage',
  components: {
    AppHeader,
    AppFooter,
    PageTitle
  },
  data() {
    return {
      selectedDay: null,
      userQuoteData: null,
      availableDays: []
    }
  },
  computed: {
    selectedMonth() {
      return this.userQuoteData?.birth_month || 1
    }
  },
  mounted() {
    this.loadUserData()
    this.generateDays()
  },
  methods: {
    loadUserData() {
      const storedData = localStorage.getItem('quoteData')
      if (storedData) {
        try {
          this.userQuoteData = JSON.parse(storedData)
          // 检查是否有选择的月份
          if (!this.userQuoteData.birth_month) {
            // 如果没有选择月份，跳转回月份选择页面
            this.$router.push('/birth-month')
            return
          }
          // 加载之前选择的出生日期（如果有的话）
          if (this.userQuoteData.birth_day !== undefined) {
            this.selectedDay = this.userQuoteData.birth_day
          }
        } catch (error) {
          console.error('Error parsing stored data:', error)
          this.$router.push('/')
        }
      } else {
        // 如果没有数据，跳转回首页
        this.$router.push('/')
      }
    },
    
    saveUserData() {
      localStorage.setItem('quoteData', JSON.stringify(this.userQuoteData))
    },
    
    generateDays() {
      // 根据选择的月份生成对应的天数
      const daysInMonth = this.getDaysInMonth(this.selectedMonth)
      this.availableDays = Array.from({ length: daysInMonth }, (_, i) => i + 1)
    },
    
    getDaysInMonth(month) {
      // 返回指定月份的天数
      const daysMap = {
        1: 31,  // January
        2: 29,  // February (按要求显示29天)
        3: 31,  // March
        4: 30,  // April
        5: 31,  // May
        6: 30,  // June
        7: 31,  // July
        8: 31,  // August
        9: 30,  // September
        10: 31, // October
        11: 30, // November
        12: 31  // December
      }
      return daysMap[month] || 31
    },
    
    async selectDay(day) {
      this.selectedDay = day
      
      // 检查是否是添加驾驶员模式
      if (this.userQuoteData.adding_driver && this.userQuoteData.temp_driver) {
        // 添加驾驶员模式：更新临时驾驶员数据
        this.userQuoteData.temp_driver.birth_day = day
        console.log('Selected birth day for additional driver:', day)
      } else {
        // 主驾驶员模式：更新主驾驶员数据
        this.userQuoteData.birth_day = day
        console.log('Selected birth day for primary driver:', day)
      }
      
      this.saveUserData()
      
      // 提交数据并记录页面提交事件
      await submitDataAndLog('birthday')
      // 跳转到出生年份选择页面
      this.$router.push('/birth-year')
    },
    
    goBack() {
      this.$router.push('/birth-month')
    }
  }
}
</script>

<style scoped>
/* Page Layout */
.birth-day-page {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}

/* Navigation */
.navigation {
  padding: 1rem 0;
}

.back-btn {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  background: none;
  border: none;
  color: #999;
  font-size: 0.9rem;
  cursor: pointer;
  transition: color 0.3s ease;
}

.back-btn:hover {
  color: #666;
}

/* Birth Day Section */
.birth-day-section {
  padding: 2rem 0 4rem;
  background: #fff;
  flex: 1;
}

.birth-day-content {
  text-align: center;
  max-width: 1000px;
  margin: 0 auto;
}

.days-grid {
  display: grid;
  grid-template-columns: repeat(15, 1fr);
  gap: 0.5rem;
  margin-bottom: 2rem;
}

.day-button {
  padding: 0.8rem 0.5rem;
  border: 2px solid #e9ecef;
  border-radius: 8px;
  background: #fff;
  color: #007bff;
  font-size: 0.9rem;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.3s ease;
  min-height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  text-align: center;
}

.day-button:hover {
  border-color: #007bff;
  background: #f8f9fa;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.15);
}

.day-button.selected {
  border-color: #007bff;
  background: #007bff;
  color: #fff;
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0,123,255,0.3);
}

/* Responsive Design */
@media (max-width: 768px) {
  .birth-day-content {
    padding: 0 1rem;
  }

  .days-grid {
    grid-template-columns: 1fr;
    gap: 0.8rem;
  }

  .day-button {
    padding: 1rem;
    font-size: 0.9rem;
    min-height: 55px;
  }

  .birth-day-section {
    padding: 1.5rem 0 2rem;
  }
}

@media (max-width: 480px) {
  .days-grid {
    gap: 0.6rem;
  }

  .day-button {
    padding: 0.9rem;
    font-size: 0.85rem;
    min-height: 50px;
  }

  .birth-day-section {
    padding: 1rem 0;
  }
}
</style>
